import { useEffect, useState } from 'react';
import { decode, encodeURI } from 'js-base64';
import isEmpty from 'lodash/isEmpty';
import { parse } from 'query-string';
import { ApiQueryOperator, IApiQueryParam } from 'types';

const pushEncodedURIForQuery = (query: Record<string, unknown>, dataKey: string) => {
  let queryParams = '';

  if (!isEmpty(query)) {
    const stringifiedQuery = JSON.stringify({ [dataKey]: query });
    const encodedURIQuery = encodeURI(stringifiedQuery);
    queryParams = `?data=${encodedURIQuery}`;
  }

  const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${queryParams}`;

  window.history.replaceState({ path: newurl }, '', newurl);
};

const decodeUrlData = (location: Location, dataKey: string) => {
  try {
    const { data } = parse(location.search);
    if (data) {
      const decodedData = decode(data as string);
      return JSON.parse(decodedData)?.[dataKey];
    }
    return null;
  } catch (e) {
    return undefined;
  }
};

export const getQueryStringValue = (urlQuery: IApiQueryParam[], key: string, operator: ApiQueryOperator) => (urlQuery || []).find((item: IApiQueryParam) => item.key === key && item.operator === operator)?.value;

export const useQueryString = (dataKey: string, location: Location, initialState?: Record<string, unknown>): any => {
  const [state, setState] = useState({ ...initialState, ...decodeUrlData(location, dataKey) });

  useEffect(() => {
    pushEncodedURIForQuery(state, dataKey);
  }, [state, dataKey]);

  const setQuery = (values: Record<string, unknown>): void => {
    const newQuery = {
      ...state,
      ...values,
    };

    setState(newQuery);
  };

  return [state, setQuery];
};
